/* itg-product.js — Sticky ATC, CAB bundle, thumbnail slider */

/* ── Sticky Add-to-Cart bar ─────────────────────────────────────────── */
class ItgStickyAtc extends HTMLElement {
  connectedCallback() {
    this.mainBtn = Array.from(
      document.querySelectorAll(".product-form__submit"),
    ).find((btn) => !this.contains(btn));
    if (!this.mainBtn) return;

    this.atcBtn = this.querySelector(".itg-sticky-atc__btn--atc");
    this.qtyVal = this.querySelector(".itg-sticky-atc__qty-val");
    this.minus = this.querySelector("[data-itg-sticky-minus]");
    this.plus = this.querySelector("[data-itg-sticky-plus]");
    this.mainQtyInput = document.querySelector(".quantity__input");
    this.qty = parseInt(this.mainQtyInput?.value || "1", 10) || 1;

    this._initVisibility();
    this._initQty();
    this._initSoldOut();
  }

  disconnectedCallback() {
    if (this._visibilityObserver) this._visibilityObserver.disconnect();
    if (this._soldOutObserver) this._soldOutObserver.disconnect();
  }

  _initVisibility() {
    if (!("IntersectionObserver" in window)) return;
    var self = this;
    this._visibilityObserver = new IntersectionObserver(
      function (entries) {
        self.classList.toggle("is-visible", !entries[0].isIntersecting);
      },
      { threshold: 0.5 },
    );
    this._visibilityObserver.observe(this.mainBtn);
  }

  _syncQty() {
    if (this.qtyVal) this.qtyVal.textContent = this.qty;
    if (this.mainQtyInput) {
      this.mainQtyInput.value = this.qty;
      this.mainQtyInput.dispatchEvent(new Event("change", { bubbles: true }));
    }
  }

  _initQty() {
    var self = this;
    var inp = this.mainQtyInput;

    this.minus?.addEventListener("click", function () {
      var min = parseInt(inp?.getAttribute("data-min") || "1", 10);
      if (self.qty > min) {
        self.qty--;
        self._syncQty();
      }
    });

    this.plus?.addEventListener("click", function () {
      var maxAttr = inp?.getAttribute("data-max");
      var max = maxAttr ? parseInt(maxAttr, 10) : Infinity;
      if (self.qty < max) {
        self.qty++;
        self._syncQty();
      }
    });

    inp?.addEventListener("change", function () {
      var v = parseInt(inp.value, 10);
      if (!isNaN(v) && v !== self.qty) {
        self.qty = v;
        if (self.qtyVal) self.qtyVal.textContent = v;
      }
    });

    this.atcBtn?.addEventListener("click", function () {
      if (inp) inp.value = self.qty;

      /* Show spinner on the sticky button */
      self._setLoading(true);

      /* Trigger Dawn's product-form submit handler */
      var form = self.mainBtn.closest("form");
      if (form && form.requestSubmit) {
        form.requestSubmit(self.mainBtn);
      } else if (form) {
        form.submit();
      } else {
        self.mainBtn.click();
      }

      /* Stop spinner when the cart drawer opens (active class added) or
         after a safety timeout in case something goes wrong */
      var cartDrawer = document.querySelector("cart-drawer");
      if (cartDrawer) {
        var drawerObserver = new MutationObserver(function (mutations) {
          mutations.forEach(function (m) {
            if (
              m.type === "attributes" &&
              m.attributeName === "class" &&
              cartDrawer.classList.contains("active")
            ) {
              drawerObserver.disconnect();
              self._setLoading(false);
            }
          });
        });
        drawerObserver.observe(cartDrawer, {
          attributes: true,
          attributeFilter: ["class"],
        });
        /* Safety fallback — stop after 6 s no matter what */
        setTimeout(function () {
          drawerObserver.disconnect();
          self._setLoading(false);
        }, 6000);
      } else {
        /* No cart drawer (cart page redirect) — stop immediately */
        self._setLoading(false);
      }
    });
  }

  _setLoading(on) {
    var btn = this.atcBtn;
    if (!btn) return;
    var icon = btn.querySelector(".itg-sticky-atc__icon");
    var spinner = btn.querySelector(".itg-sticky-atc__spinner");
    var label = btn.querySelector(".itg-sticky-atc__btn-text");
    btn.disabled = on;
    if (icon) icon.hidden = on;
    if (spinner) spinner.hidden = !on;
    if (label) label.textContent = on ? "Adding…" : "Add to Cart";
  }

  _initSoldOut() {
    var self = this;
    var sync = function () {
      self.classList.toggle(
        "is-sold-out",
        self.mainBtn.disabled || self.mainBtn.name === "sold_out",
      );
    };
    this._soldOutObserver = new MutationObserver(sync);
    this._soldOutObserver.observe(this.mainBtn, {
      attributes: true,
      attributeFilter: ["disabled", "name"],
    });
    sync();
  }
}

customElements.define("itg-sticky-atc", ItgStickyAtc);

/* ── CAB combo bundle ───────────────────────────────────────────────── */
class ItgCabBundle extends HTMLElement {
  connectedCallback() {
    this.fmt = new Intl.NumberFormat("en-US", {
      style: "currency",
      currency: "USD",
    });
    this.atcBtn = this.querySelector("[data-itg-cab-atc]");
    this.totalEl = this.querySelector("[data-itg-cab-total]");
    this.savingsEl = this.querySelector("[data-itg-cab-savings]");

    /* Pre-parse check data to avoid repeated dataset reads */
    this.checks = [];
    var self = this;
    this.querySelectorAll(".itg-cab-bundle__check").forEach(function (cb) {
      self.checks.push({
        cb: cb,
        price: parseInt(cb.dataset.price, 10) || 0,
        compare: parseInt(cb.dataset.compare || "0", 10),
        variantId: parseInt(cb.dataset.variantId, 10),
      });
      cb.addEventListener("change", function () {
        self._updateTotals();
      });
    });

    this._updateTotals();
    this.atcBtn?.addEventListener("click", function () {
      self._addToCart();
    });
  }

  _fmt(cents) {
    return this.fmt.format(cents / 100);
  }

  _updateTotals() {
    var total = 0,
      savings = 0;
    for (var i = 0; i < this.checks.length; i++) {
      var d = this.checks[i];
      if (!d.cb.checked) continue;
      total += d.price;
      if (d.compare > d.price) savings += d.compare - d.price;
    }
    if (this.totalEl) this.totalEl.textContent = this._fmt(total);
    if (this.savingsEl) {
      this.savingsEl.hidden = savings <= 0;
      if (savings > 0)
        this.savingsEl.textContent = "You save " + this._fmt(savings);
    }
  }

  _addToCart() {
    var selected = this.checks.filter(function (d) {
      return d.cb.checked;
    });
    if (!selected.length) return;

    var btn = this.atcBtn;
    var origHTML = btn.innerHTML;
    btn.disabled = true;
    btn.innerHTML =
      '<i class="ph ph-circle-notch" aria-hidden="true"></i> Adding…';

    var cart =
      document.querySelector("cart-drawer") ||
      document.querySelector("cart-notification");
    var items = selected.map(function (d) {
      return { id: d.variantId, quantity: 1 };
    });
    var sectionsParam = cart
      ? cart.getSectionsToRender().map(function (s) {
          return s.id;
        })
      : [];
    var body = sectionsParam.length
      ? {
          items: items,
          sections: sectionsParam,
          sections_url: window.location.pathname,
        }
      : { items: items };

    var self = this;
    fetch("/cart/add.js", {
      method: "POST",
      headers: { "Content-Type": "application/json" },
      body: JSON.stringify(body),
    })
      .then(function (res) {
        if (!res.ok) throw new Error();
        return res.json();
      })
      .then(function (response) {
        btn.innerHTML = '<i class="ph ph-check" aria-hidden="true"></i> Added!';
        if (cart) {
          cart.renderContents(response);
          document.dispatchEvent(new CustomEvent("cart:refresh"));
        } else {
          window.location = window.routes.cart_url;
        }
        setTimeout(function () {
          btn.disabled = false;
          btn.innerHTML = origHTML;
        }, 2000);
      })
      .catch(function () {
        btn.disabled = false;
        btn.innerHTML = origHTML;
      });
  }
}

customElements.define("itg-cab-bundle", ItgCabBundle);

/* ── Thumbnail rail slider (vertical desktop ≥750px / horizontal mobile) ── */
(function () {
  var DESKTOP_ITEM_SIZE = 72 + 16; /* thumb height + gap */
  var DESKTOP_VISIBLE = 6;
  var MOBILE_VISIBLE = 3;
  var STEP = 3;

  function isMobile() {
    return window.innerWidth < 750;
  }

  function initThumbSlider(sliderEl) {
    var list =
      sliderEl.querySelector(".itg-thumb-viewport .thumbnail-list") ||
      sliderEl.querySelector(".thumbnail-list");
    var prevBtn = sliderEl.querySelector(".itg-thumb-nav--up");
    var nextBtn = sliderEl.querySelector(".itg-thumb-nav--down");
    if (!list || !prevBtn || !nextBtn) return;

    var offset = 0;

    function itemSize() {
      var firstItem = list.querySelector(".thumbnail-list__item");
      if (!firstItem) return DESKTOP_ITEM_SIZE;
      if (isMobile()) {
        var marginRight =
          parseFloat(window.getComputedStyle(firstItem).marginRight) || 16;
        return firstItem.offsetWidth + marginRight;
      }
      var style = window.getComputedStyle(list);
      var gap = parseFloat(style.gap) || parseFloat(style.rowGap) || 16;
      return firstItem.offsetHeight + gap;
    }

    function visibleCount() {
      return isMobile() ? MOBILE_VISIBLE : DESKTOP_VISIBLE;
    }

    function maxOffset() {
      var totalItems = list.querySelectorAll(".thumbnail-list__item").length;
      return Math.max(0, (totalItems - visibleCount()) * itemSize());
    }

    function applyScroll(smooth) {
      list.style.transition = smooth ? "transform 0.3s ease" : "none";
      if (isMobile()) {
        list.style.transform = "translateX(-" + offset + "px)";
      } else {
        list.style.transform = "translateY(-" + offset + "px)";
      }
      prevBtn.disabled = offset <= 0;
      nextBtn.disabled = offset >= maxOffset();
    }

    prevBtn.addEventListener("click", function () {
      offset = Math.max(0, offset - STEP * itemSize());
      applyScroll(true);
    });

    nextBtn.addEventListener("click", function () {
      offset = Math.min(maxOffset(), offset + STEP * itemSize());
      applyScroll(true);
    });

    /* When a variant is selected, media-gallery sets aria-current="true" on
       the matching thumbnail. Scroll it into view. */
    new MutationObserver(function (mutations) {
      mutations.forEach(function (mutation) {
        if (
          mutation.type !== "attributes" ||
          mutation.attributeName !== "aria-current"
        )
          return;
        var btn = mutation.target;
        if (btn.getAttribute("aria-current") !== "true") return;
        var item = btn.closest(".thumbnail-list__item");
        if (!item) return;
        var itemIndex = Array.from(
          list.querySelectorAll(".thumbnail-list__item"),
        ).indexOf(item);
        if (itemIndex < 0) return;
        var size = itemSize();
        var visible = visibleCount();
        var itemStart = itemIndex * size;
        var itemEnd = itemStart + size;
        var viewEnd = offset + visible * size;
        if (itemStart < offset) {
          offset = Math.max(0, itemStart);
          applyScroll(true);
        } else if (itemEnd > viewEnd) {
          offset = Math.min(maxOffset(), itemEnd - visible * size);
          applyScroll(true);
        }
      });
    }).observe(list, {
      subtree: true,
      attributes: true,
      attributeFilter: ["aria-current"],
    });

    /* Reset on breakpoint crossing */
    window.addEventListener("resize", function () {
      offset = 0;
      list.style.transition = "none";
      list.style.transform = "";
      applyScroll(false);
    });

    applyScroll(false);
  }

  function initAllThumbSliders() {
    document
      .querySelectorAll(
        ".thumbnail-slider.itg-thumb-scroll, .thumbnail-slider.itg-thumb-scroll-mobile",
      )
      .forEach(initThumbSlider);
  }

  if (document.readyState === "loading") {
    document.addEventListener("DOMContentLoaded", initAllThumbSliders);
  } else {
    initAllThumbSliders();
  }
})();

/* ── Instant variant image switch ───────────────────────────────────────── */
/* Switches the main gallery image immediately on variant select,
   before product-info.js fetch resolves. Also applies on page load so the
   first/pre-selected variant image is always shown correctly. */
(function () {
  var dataEl = document.querySelector("[id^='VariantMediaMap-']");
  if (!dataEl) return;

  var data;
  try {
    data = JSON.parse(dataEl.textContent);
  } catch (e) {
    return;
  }

  var sectionId = data.sectionId;
  var variantMedia = data.variantMedia; /* { variantId: mediaId|null } */
  var optionMap = data.optionMap; /* [{ id, optionValues: [...] }] */

  /* Numeric sort so large Shopify IDs compare correctly */
  function numSort(arr) {
    return arr.slice().sort(function (a, b) {
      return Number(a) - Number(b);
    });
  }

  /* Build lookup: sorted-option-value-ids key -> variantId */
  var optionLookup = {};
  optionMap.forEach(function (v) {
    var key = numSort(v.optionValues).join(",");
    optionLookup[key] = v.id;
  });

  function resolveVariantId(selectedOptionValues) {
    var key = numSort(selectedOptionValues).join(",");
    return optionLookup[key] || null;
  }

  function switchImage(variantId) {
    var mediaId = variantMedia[variantId];
    if (!mediaId) return;
    var gallery = document.querySelector(
      "[id='MediaGallery-" + sectionId + "']",
    );
    if (!gallery || typeof gallery.setActiveMedia !== "function") return;
    gallery.setActiveMedia(sectionId + "-" + mediaId, false);
  }

  /* Read the currently-checked inputs to get active option-value-ids */
  function getSelectedOptionValueIds() {
    return Array.from(
      document.querySelectorAll(
        "variant-selects select option[selected], variant-selects fieldset input:checked",
      ),
    ).map(function (el) {
      return el.dataset.optionValueId;
    });
  }

  /* Apply image for whatever variant is selected right now */
  function applyCurrentVariant() {
    var ids = getSelectedOptionValueIds();
    if (!ids.length) return;
    var variantId = resolveVariantId(ids);
    if (variantId) switchImage(variantId);
  }

  /* On page load — show correct image for the pre-selected (first) variant */
  if (document.readyState === "loading") {
    document.addEventListener("DOMContentLoaded", applyCurrentVariant);
  } else {
    applyCurrentVariant();
  }

  /* On every variant change — switch instantly before fetch resolves */
  if (typeof subscribe === "function" && typeof PUB_SUB_EVENTS === "object") {
    subscribe(PUB_SUB_EVENTS.optionValueSelectionChange, function (event) {
      var selectedOptionValues =
        event && event.data && event.data.selectedOptionValues;
      if (!selectedOptionValues) return;
      var variantId = resolveVariantId(selectedOptionValues);
      if (variantId) switchImage(variantId);
    });
  }
})();
